export default function SavedItemList() {
  return {
    savedProducts: [
      {
        productId: '1600383398',
      },
      {
        productId: '1600426245',
      },
      {
        productId: '1454629136',
      },
      {
        productId: '1600005656',
      },
      {
        productId: '1600121972',
      },
    ],
  };
}
